import { SharedEmpty, SharedTable } from '@components';
import { UnavailabilityHook } from '@models';
import React from 'react';
import { Columns } from './UnavailabilityTable.columns';

interface TableProps {
  unavailabilityHook: UnavailabilityHook;
  handleDelete: (id: string) => Promise<void>;
}

const UnavailabilityTable: React.FC<TableProps> = ({ unavailabilityHook, handleDelete }) => {
  // An empty table - headers, scrollbars and antd's own "No data" - reads as broken; the app's
  // empty state says it in the same words as everywhere else.
  if (!unavailabilityHook.loading && unavailabilityHook.dataSource.length === 0) {
    return <SharedEmpty description="Nothing scheduled - the garage is available" />;
  }

  return <SharedTable {...unavailabilityHook} columns={Columns({ handleDelete })} />;
};

export default UnavailabilityTable;
